import Cookies from "js-cookie";
import axios from "axios";
import {API_URL} from "api/config";

import {createSlice, createDraftSafeSelector, createAsyncThunk} from '@reduxjs/toolkit'

export const initialState = {
  isInvalidated: true,
  isFetching: false,
  username: "",
  firstname: "",
  lastname: "",
  email: "",
  gender_iso5218: 1,
  country: "",
  roles: "",
  loggedInAt: null,
}

export const fetchUser = createAsyncThunk(
  "team/playerListLoading",
  () => axios
    .get(process.env.REACT_APP_MYBUILDINGSAPI + "user")
    .then((response) => response.data)
    .catch((error) => error)
);

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    invalidateUser(state) {
      state = {...initialState}
    },
  },
  extraReducers: {
    [fetchUser.pending.type]: (state, action) => {
      state.isFetching = true
      state.isInvalidated = false
    },
    [fetchUser.fulfilled.type]: (state, action) => {
      state.isFetching = false
      state.isInvalidated = false
      state.username = action.payload.username
      state.realname = action.payload.realname
      state.firstname = action.payload.firstname
      state.lastname = action.payload.lastname
      state.email = action.payload.email
      state.gender_iso5218= action.payload.gender_iso5218
      state.country = action.payload.country
      state.roles = action.payload.roles
      state.loggedInAt = Date.now ? Date.now() : new Date().getTime()
    },
    [fetchUser.rejected.type]: (state, action) => {
      state.isFetching = false
    },
  },
})

export const {requestUser, invalidateUser, fetchUserFailure, writeUserData} = userSlice.actions
export default userSlice.reducer

export const shouldFetchUserData = (state) => {
  return (
    (!state.username && !state.email && !state.isFetching) ||
    Cookies.get("access_token") === ""
  );
};

export const fetchUserDataIfNeeded = () => {
  return (dispatch, getState) => {
    if (Cookies.get("access_token") === undefined) {
      dispatch(invalidateUser());
    } else if (shouldFetchUserData(getState().user)) {
      return dispatch(fetchUserData());
    }
  };
};

//Async action creators
export const fetchUserData = () => {
  return (dispatch, getState) => {
    dispatch(requestUser());
    let apiUrl = process.env.REACT_APP_MYBUILDINGSAPI + "user"; //eslint-disable-line no-undef
    let xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        dispatch(writeUserData(JSON.parse(this.responseText)));
      } else {
        dispatch(fetchUserFailure());
      }
    });
    xhr.open("GET", apiUrl);
    xhr.setRequestHeader(
      "Authorization",
      "Bearer " + Cookies.get("access_token")
    );
    xhr.send();
  };
};

//Selectors
export const getUser = (state) => state.user;
export const getUserName = (state) => state.user.username;

export const getIsLoggedIn = (state) => {
  return (
    state.user.username !== "" && Cookies.get("access_token") !== undefined
  );
};

export const getIsUserFetching = (state) => {
  return state.user.isFetching;
};

export const ssoAuth = (code, state) => {
  return axios
    .post(`${API_URL}/api/auth/sso/token`, {code, state})
    .then(() => true)
    .catch(() => {
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      return false;
    });
};

export const ssoRefresh = () => {
  if (!Cookies.get("refresh_token")) {
    return Promise.resolve(false);
  }
  return axios
    .post(`${API_URL}/api/auth/sso/refresh`)
    .then(() => true)
    .catch(() => {
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      return false;
    });
};

axios.interceptors.request.use(
  function (config) {
    const token = Cookies.get("access_token");

    if (token !== undefined) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  function (err) {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    try {
      const {
        config,
        response: { status },
      } = error;
      const originalRequest = config;

      if (status === 401 && !config.url.includes("/api/auth/sso/")) {
        ssoRefresh().then((resp) => {
          if (resp) {
            return originalRequest;
          }
        });
      }
      return Promise.reject(error);
    } catch (e) {
      console.log("Auth. error");
      return Promise.reject(error);
    }
  }
);
